import { FrameModules } from 'Shared/frame_modules';

FrameModules.add('CommentsWatchFrameModule', () => {
   let on = $('commentsWatchOn');
   let off = $('commentsWatchOff');

   when(on, on => {
      on.getFirst('.js-toggle-watch').addEvent('click', function (ev) {
         ev.stop();
         new Request.AjaxIO('watch', {
            onSuccess: function () {
               on.hide();
               off.show('inline');
            },
         }).send('on', this.get('data-context'), this.get('data-contextid'));
      });
   });

   when(off, off => {
      off.getFirst('.js-toggle-watch').addEvent('click', function (ev) {
         ev.stop();
         new Request.AjaxIO('watch', {
            onSuccess: function () {
               off.hide();
               on.show('inline');
            },
         }).send('off', this.get('data-context'), this.get('data-contextid'));
      });
   });
});
